<template>
  <div
    class="modals"
    :css="{'z-index': 200 + index}"
  >
    <div class="modals__content">
      <div class="remove-scroll-width">
        <div class="modals__content__inner">
          <div class="modals__close">
            <span @click="CloseModal">
              <font-awesome-icon :icon="['far', 'times-circle']" />
            </span>
          </div>
          <component
            :is="ModalData.component"
            ref="modalContent"
            v-bind="{store, index, ConnectionInformation}"
            :modal-data="ModalData"
            :socket-message = "SocketMessage"
            :page-message = "PageMessage"
            @SetPageMessage = "SetPageMessage"
            @CloseModal = "CloseModal"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

import About from '@/components/About'
import DialogueModal from '@/components/DialogueModal'
import EditPrograms from '@/components/EditPrograms'
import EditStations from '@/components/EditStations'
import EditSensors from '@/components/EditSensors'
import JSControl from '@/components/JSControl'
import RainShutDown from '@/components/RainShutDown'
import RegulateProgram from '@/components/RegulateProgram'
import StationsSetTime from '@/components/StationsSetTime'
import SyncModal from '@/components/SyncModal'
import TimeoutModal from '@/components/TimeoutModal'
import Settings from '@/components/Settings'

import AlarmHandler from '@/components/elements/AlarmHandler'


export default {
  name: 'Modal',
  components:
  {
    'font-awesome-icon': FontAwesomeIcon,
    About,
    JSControl,
    RainShutDown,
    StationsSetTime,
    EditPrograms,
    EditStations,
    EditSensors,
    RegulateProgram,
    TimeoutModal,
    SyncModal,
    DialogueModal,
    Settings,
    AlarmHandler
  },
  props:
  {
    index: {
      type: Number,
      default: 0
    },
    ModalData: {
      type: Object,
      default: function() {
        return{
          name: 'modals',
          modalData: {}
        }
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ConnectionInformation: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  mounted() {
    document.body.classList.add('modal-open')
  },
  methods:
  {
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    },
    CloseModal(data) {

      // prevent user from closing modal window while syncing
    if(window.syncing === true){
        return false
    }

      if(this.$refs.modalContent && this.$refs.modalContent.canModalClose !== undefined) {
        const canModalClose = this.$refs.modalContent.canModalClose()

        if(canModalClose) {
          this.$emit('CloseModal', this.ModalData.component)
        }
      } else {
        this.$emit('CloseModal', this.ModalData.component)
      }
    }
  }
}
</script>

<style lang="scss">
$spacing: 66px;

.modals {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: $z-modal;
  transition: all 0.2s;
  opacity: 0;
  background: rgba($color-black, 0.55);

  .modal-open & {
    transition: all 0.4s;
    opacity: 1;
  }

  &__close {
    font-size: 40px;
    color: $color-white;
    display: block;
    text-align: center;
    z-index: 1;
    padding-bottom: 10px;

    cursor: pointer;
    overflow: hidden;
    // > * {
    //   border-radius: 50%;
    //   display: inline-block;
    //   text-align: right;
    //   background-color: rgba($color-black, 0.3);
    // }
  }

  &__content {
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 3;
    padding-top: $spacing;
    overflow-y: auto;

    &__inner {
      @include clearfix();

      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      transition: all 0.4s;
      padding-bottom: $spacing;

      .modal-open & {
      }
    }
  }

  .remove-scroll-width {
    height: 100%;
    // margin-left: calc(100vw - 100%); // https://css-tricks.com/elegant-fix-jumping-scrollbar-issue/
  }
}

@media screen and (min-width: $bp-mobile) {
  .modals {
    &__close {
      text-align: right;
      
      > * {
        // transform: translateX(-100%)
      }
    }
  }
}
</style>
